// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kwPO","delete":"styles_delete__2pdoj","update":"styles_update__bgjn7","add":"styles_add__37REi"};